import { getUID } from './storage';

export const dbPushData = function (nextSlide = false) {
	if (getUID()) {
		const state = this.state;
		const uID = getUID();

		const formData = {
			forms: {
				form_id: state.id,
				form_name: state.title,
				location: window.location.hostname + window.location.pathname,
				user_id: uID,
				completed: +(state.userData.progress >= state.slides.indexOf(state.slides.filter((slide) => slide.type === 'results')[0])),
				progress: state.userData.progress,
				last_slide: state.position,
			},
		};

		// If user switched to next slide
		if (nextSlide) {
			/**
			 * Check if scores can be sent to the database
			 */

			// Loop dimensions in userData and check which of those have a valid score
			const dimensionScore = [];
			Object.keys(state.userData.dimensions).map((d) => {
				if ('score' in state.userData.dimensions[d] && state.userData.dimensions[d].score !== false) {
					// Build string, for example: "Collect: 34"
					dimensionScore.push(state.dimensions[d].name + ': ' + state.userData.dimensions[d].score);
				}
			});
			formData.forms.dimension_score = dimensionScore.join('|');

			// Check if a total score exists
			if ('score' in state.userData && state.userData.score !== false) {
				formData.forms.total_score = state.userData.score;
			}

			/**
			 * Questions
			 */
			const questions = [];

			/**
			 * Questions: Check previous slide
			 */

			if (state.position > 0) {
				const prevSlide = state.slides[state.position - 1];
				if (prevSlide.type === 'question') {
					const prevQuestion = {
						form_id: state.id,
						user_id: uID,
						// end_timestamp
						question_id: prevSlide.ID,
						question_type: prevSlide.input_type,
						dimension: prevSlide.dimension,
						question_text: prevSlide.title,
					};

					let results = state.userData.dimensions[prevSlide.dimension].results[prevSlide.ID];
					let answerText;

					if (prevSlide.input_type === 'scale' && prevSlide.scale_options.type === 'percentage') {
						answerText = results.answers;
					} else {
						if (Array.isArray(results.answers)) {
							const answers = [];
							results.answers.forEach((val) => {
								answers.push(prevSlide.answers[val].label);
							});
							answerText = answers.join('|');
						} else {
							answerText = prevSlide.answers[results.answers].label;
						}
					}

					prevQuestion.answer = answerText;

					if ('score' in results) {
						prevQuestion.answer_score = results.score;
					}

					questions.push(prevQuestion);
				}
			}

			/**
			 * Questions: Check current slide
			 */
			const currentSlide = state.slides[state.position];
			if (currentSlide.type === 'question') {
				questions.push({
					form_id: state.id,
					user_id: uID,
					question_id: currentSlide.ID,
					question_type: currentSlide.input_type,
					dimension: currentSlide.dimension,
					question_text: currentSlide.title,
				});
			}

			if (questions.length) {
				formData.questions = questions;
			}
		}

		/**
		 * Send data
		 */

		dbFetch(formData, state);
	}
};

export const dbFetch = function (data, state) {
	fetch(state.apiRout.itdms_ajax + '?action=' + window.itdms_ajax.db_action, {
		method: 'POST',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});
};
